import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    IResponseData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {BS2GameMode} from "./server/BS2GameMode";
import {BS2GameData} from "./server/BS2Data";
import {BS2Sound} from "./config/sound/BS2Sound";
import {BS2} from "./BS2";
import {RestoreUtils} from "./utils/RestoreUtils";
import {BS2Statics} from "./config/BS2Statics";

export class BS2PromoPanelConfig implements PromoPanelGameConfiguration {
    private triggeredFs: boolean = false;
    private roundWin: number = 0;

    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "BloodAndShadow2",
            hasActionSpin: true,
            graphics: {backgroundTextureName: "introBg"},
            getParsedData: (response: BS2GameData, bet: number, prevResponse: BS2GameData): ASWinData => {
                const spinWin = this.getSpinWin(response, bet, prevResponse);
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    totalSpinWinnings: spinWin,
                    isBigWin: this.isBigWin(response, spinWin),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank,
                }
                if (response.nextMode == BS2GameMode.NORMAL) {
                    this.triggeredFs = false;
                }
                return parsedData;
            }
        };
    }

    //Triggered this spin needs to be true as well. Then this check needs to be true.
    public isLegalStopOnBonusMode(data: IResponseData): boolean {
        return data.mode == BS2GameMode.NORMAL || data.mode == BS2GameMode.AVALANCHE_NORMAL || data.mode == BS2GameMode.AVALANCHE_FREESPIN || data.mode === BS2GameMode.FREESPIN_SUPER || data.mode === BS2GameMode.AVALANCHE_FREESPIN_SUPER;
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            BS2.soundPlayer.playSound(BS2Sound.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            BS2.soundPlayer.playSound(BS2Sound.AS_WIN_BIG);
        }
    }

    public onPlayBonusInGame(data: any): void {
        RestoreUtils.startupGame(true, true);
        BS2.apiPlugin.slotStates.resetGameStartedAndGameServerFlag();
        BS2.model.onGame(data);
        setTimeout(() => {
            BS2.gameFlowController.start()
        }, 500);
    }

    private isBigWin(response: BS2GameData, spinWin: number): boolean {
        let win = spinWin;

        if (response.wasFeatureBuy || (response.enhancedBet && BS2.model.buyFeatureName === BS2Statics.BOOSTED_BET_2)) {
            const betPrice = BS2.getBetPrice();
            let winRatio: number = Helper.ceilToDecimals((win / betPrice), 4);
            return winRatio >= 1;
        }

        let winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 4);
        return winRatio >= 15;
    }

    private getSpinWin(response: BS2GameData, bet: number, prevData: BS2GameData): number {
        return response.totalSpinWinnings;
    }

    private isFreeSpinTriggered(response: BS2GameData): boolean {
        if (response.featureName === BS2Statics.BOOSTED_BET_2 && response.nextMode === BS2GameMode.FREESPIN_SUPER && !this.triggeredFs && response.freespinsLeft > 0) {
            this.triggeredFs = true
            return true;
        }

        if ((response.mode === BS2GameMode.NORMAL || response.mode === BS2GameMode.AVALANCHE_NORMAL || response.mode === BS2GameMode.AVALANCHE_FREESPIN) && response.nextMode === BS2GameMode.FREESPIN && this.triggeredFs === false) {
            this.triggeredFs = true;
            return true;
        }

        if ((response.mode === BS2GameMode.NORMAL || response.mode === BS2GameMode.AVALANCHE_NORMAL || response.mode === BS2GameMode.FREESPIN || response.mode === BS2GameMode.AVALANCHE_FREESPIN  || response.mode === BS2GameMode.AVALANCHE_FREESPIN_SUPER)
            && response.nextMode == BS2GameMode.FREESPIN_SUPER && this.triggeredFs === false) {
            this.triggeredFs = true
            return true;
        }
        return false;
    }

    private getFeatureName(response: BS2GameData): string {
        if (response.mode == BS2GameMode.FREESPIN_SUPER || response.nextMode == BS2GameMode.FREESPIN_SUPER || response.mode == BS2GameMode.AVALANCHE_FREESPIN_SUPER || response.nextMode == BS2GameMode.AVALANCHE_FREESPIN_SUPER) {
            return "Reign of Terror Spins ";
        }

        if (response.mode == BS2GameMode.FREESPIN || response.nextMode == BS2GameMode.FREESPIN || response.mode == BS2GameMode.AVALANCHE_FREESPIN || response.nextMode == BS2GameMode.AVALANCHE_FREESPIN) {
            return "Candle Spins " + BS2.apiPlugin.translations.translate("Level") + " " + (response.currentLevel === 0 ? response.nextLevel : response.currentLevel);
        }
        return response.mode;
    }

    private isRoundComplete(response: BS2GameData): boolean {
        return ([BS2GameMode.FREESPIN_SUPER, BS2GameMode.FREESPIN, BS2GameMode.NORMAL].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: BS2GameData): boolean {
        return (response.nextMode === BS2GameMode.NORMAL) && (response.mode === BS2GameMode.FREESPIN || response.mode === BS2GameMode.FREESPIN_SUPER);
    }
}